var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"info-mode":"","collapsed":"","collapsible":_vm.isCollapsible,"title":_vm.sectionTitle,"help":_vm.sectionHelp,"help-collapsed":_vm.sectionHelp}},[(_vm.rtnReceiveList.length > 0)?[_c('RtnReceiveRelatedList2',{attrs:{"dataList":_vm.rtnReceiveList}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }